import { ca } from '@cian/analytics';

interface ITrackNewbuildingCardClickParams {
  newbuilding: { id: number };
  offerId: number;
  position: number;
}

export const trackNewbuildingCardClick = (params: ITrackNewbuildingCardClickParams) => {
  const { offerId, newbuilding, position } = params;

  ca('eventSite', {
    action: 'click_sopr',
    category: 'Card',
    label: 'other_JK',
    name: 'oldevent',
    page: {
      extra: {
        is_premium: true,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: {
          position: position + 1,
          to_object: newbuilding.id,
        },
      },
    ],
  });
};
